import React, { memo } from 'react';
import { ProductCard } from './ProductCard';
import { CheckCircle } from 'lucide-react';
export function RankingSection() {
  const products = [{
    rank: 1,
    brandName: 'Faith & Fig 4:14 Saffron',
    tagline: 'Clinical-grade Potency and Dosing, Best Overall for Focus, Mood & Dopamine Regulation',
    rating: 9.8,
    grade: 'A+',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/36128008-8b6f-473a-bed4-a1d7911e8970.png?v=1764132161',
    summary: 'From the very first week of research, Faith & Fig\'s saffron supplement left the others in the dust. Women consistently reported calmer mornings, steadier reactions throughout the day, better follow-through on tasks, and - most importantly - being able to stay present during prayer and with their families. And the best part? These results weren\'t just a temporary "honeymoon phase." The effects stayed steady week after week - without the emotional blunting many women experience on stimulant medications.',
    keyStrengths: [<>
          Clinically correct dosing — 30mg of Safr'Inside standardized saffron
          extract, the exact amount used in clinical trials showing results
          comparable to Ritalin, without stimulant side effects.
        </>, 'Targets the full calm-regulate-focus loop — Saffron\'s three active compounds (crocin, safranal, crocetin) work together to support emotional balance, mental clarity, and parasympathetic nervous system activation (your body\'s natural "calm down" system)', "Biblical sourcing — Saffron is mentioned in Song of Solomon 4:14 as a precious spice, and Faith & Fig specifically positions this as using God's creation for stewardship of your mind", 'Research-backed for focus & mood — Multiple clinical studies show saffron improves working memory, attention, emotional balance, anxiety symptoms, and sleep quality', 'No emotional blunting — Unlike stimulants that can make you feel like a "detached", women report feeling more like themselves — just calmer and more focused'],
    ratingsGrid: {
      effectiveness: 9.9,
      formulaQuality: 9.8,
      value: 9.7,
      customerSatisfaction: 9.8,
      returnPolicy: 9.7
    },
    pros: ['Only supplement with clinically potent and dosed saffron (30mg)', 'Backed by studies showing effectiveness comparable to Ritalin without stimulant side effects', 'Faith-aligned brand that addresses spiritual concerns about using supplements', 'Single-ingredient purity (Most brands use blends with unknown effects & unverified health claims)', 'Safe and effective for all ages'],
    cons: ["Only available online through Faith & Fig's website", 'Has sold out multiple times due to word-of-mouth popularity in Christian facebook groups'],
    testerQuote: 'Women testing this supplement reported being able to find motivation to clean the house from start to finish, being able to adapt when their routine or plans fell apart, and for the first time in years being able to pray without their thoughts spinning in ten different directions. Several described it as "finally feeling like the woman God created me to be.',
    isTopPick: true
  }, {
    rank: 2,
    brandName: 'BrainMD Happy Saffron Plus',
    tagline: 'High-Quality Ingredients, But Under-Dosed',
    rating: 8.5,
    grade: 'B+',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/imgi_242_happy-saffron-plus-bottle-front-saffron-supplement-brainmd.png?v=1764567855',
    summary: "BrainMD uses mainly (Affron® saffron extract + Longvida® curcumin + zinc). But the saffron is under-dosed compared to the clinical benchmark of 30mg. Not specifically for distractibility, emotional imbalances and dopamine dysregulation",
    keyStrengths: ['High-quality ingredients', 'Good for general mood support for neurotypical biohackers'],
    ratingsGrid: {
      effectiveness: 8.0,
      formulaQuality: 8.5,
      value: 7.5,
      customerSatisfaction: 8.0,
      returnPolicy: 9.0
    },
    pros: ['Reputable brand', 'mild mood support'],
    cons: ['Blend can cause digestive discomfort in sensitive women', 'Not designed for focus and mood', "Generic wellness branding & not known for their saffron supplements specifically"]
  }, {
    rank: 3,
    brandName: 'Thesis "Clarity"',
    tagline: 'Too Stimulant-Heavy for Sensitive Women',
    rating: 7.4,
    grade: 'C+',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/324b8ece-c798-480c-96ce-b77978bc06fb.png?v=1764567767',
    summary: 'Thesis markets itself as a prescription stimulant booster and has gained traction among biohackers and high-performing professionals. The problem? Its formula uses high-stimulation nootropics (CDP-Choline, Panax ginseng) which many report causes jitteriness, overstimulation, and peek anxiety.',
    keyStrengths: ['Popular among biohackers', 'Personalized approach'],
    ratingsGrid: {
      effectiveness: 7,
      formulaQuality: 7.0,
      value: 7.0,
      customerSatisfaction: 7.5,
      returnPolicy: 8
    },
    pros: ['May work for high-performing professionals'],
    cons: ['Too stimulant-adjacent for emotionally sensitive women', 'Multiple ingredients with no clinical trials', 'Many women report feeling "wired but not calm" - the opposite of what overwhelmed moms need', 'Zero spiritual alignment or acknowledgment of faith-based concerns']
  }, {
    rank: 4,
    brandName: 'Noocube Brain Productivity',
    tagline: 'Kitchen Sink Formula with Unpredictable Results',
    rating: 7.0,
    grade: 'C',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/imgi_51_1-bottle_8f9cb220-d68b-40de-b227-bf4be539db03.png?v=1764579247',
    summary: 'Noocube offers a broad "kitchen sink" formula with Lutemax® 2020, Bacopa, L-theanine, cat\'s claw, B-vitamins, and tyrosine. However, there are zero clinical trials & many reviewed it as a scam',
    keyStrengths: ['Multiple ingredients', 'General brain health focus'],
    ratingsGrid: {
      effectiveness: 7.0,
      formulaQuality: 6.5,
      value: 7.0,
      customerSatisfaction: 7.0,
      returnPolicy: 8.0
    },
    pros: ['May support general brain health'],
    cons: ['Overloaded with ingredients (unpredictable synergy and potential side effects)', 'Many users report digestive upset, headaches, and afternoon fatigue crashes', 'Generic nootropic branding with zero spiritual alignment', 'No focus on emotional regulation']
  }, {
    rank: 5,
    brandName: 'Onnit Alpha Brain',
    tagline: 'Famous Marketing, Problematic Side Effects',
    rating: 6.5,
    grade: 'C-',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/imgi_202_media_0d26030c-9e9b-40bd-82ae-df059b2ad547.png?v=1764568019',
    summary: 'Onnit is famous for its marketing and celebrity endorsements, but fame isn\'t efficacy. Major issues: Contains Huperzine A, which is known for causing nightmares, head pressure, irritability, overstimulation, and sleep disruption in many women. Not clinically validated. Uses proprietary blends (you can\'t verify actual ingredient doses). Many women report feeling "wired," "dizzy," or "emotionally flat."',
    keyStrengths: ['Well-known brand', 'Celebrity endorsements'],
    ratingsGrid: {
      effectiveness: 6.0,
      formulaQuality: 6.5,
      value: 6.5,
      customerSatisfaction: 6.0,
      returnPolicy: 7.5
    },
    pros: ['Widely available'],
    cons: ['Contains Huperzine A (known for causing nightmares and sleep disruption)']
  }];
  return <div className="bg-[#FAF8F5] py-16" data-id="element-197">
      <div className="editorial-wide" data-id="element-198">
        {/* How We Ranked Section */}
        <div className="mb-16" data-id="element-199">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-200">
            How We Ranked These Supplements
          </h2>
          <div className="bg-white p-8 rounded-xl border border-[#E8E4DD]" data-id="element-201">
            <ul className="grid md:grid-cols-2 gap-4 mb-6" data-id="element-202">
              {[<>
                  <b data-id="element-203">Clinical Dosing</b>: Does it deliver the full clinical dose
                  and real potency, or is it under-dosed to cut costs?
                </>, <>
                  <b data-id="element-204">Full-Cycle Support</b>: Do they actually support dopamine
                  stabilisation & the brain's calm-regulate-focus circuit ? Or
                  are key cofactors missing?
                </>, <>
                  <b data-id="element-205">Transparency & Quality</b>: Are ingredients clearly listed,
                  clinically studied, and manufactured to consistent standards?
                </>, <>
                  <b data-id="element-206">User Feedback</b>: Do women consistently report meaningful
                  improvements in focus, calm, and emotional steadiness?
                </>].map((criterion, index) => <li key={index} className="flex items-start gap-3 text-[#1A2332]/80" data-id="element-207">
                  <CheckCircle className="w-5 h-5 text-[#C9A961] flex-shrink-0 mt-0.5" data-id="element-208" />
                  <span data-id="element-209">{criterion}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Section Title */}
        <h2 className="text-3xl font-bold text-[#1A2332] mb-8" data-id="element-210">
          Our Top 5 Mood & Focus Supplements
        </h2>

        {/* Product Rankings */}
        <div className="space-y-8 mb-16" data-id="element-211">
          {products.map(product => <ProductCard key={product.rank} {...product} data-id="element-212" />)}
        </div>
      </div>
    </div>;
}